import {
  List,
  Datagrid,
  ReferenceField,
  ReferenceArrayField,
  ChipField,
  BooleanField,
  TextField,
  ArrayField,
  NumberField,
  DateField,
  SingleFieldList,
  ReferenceInput,
  BooleanInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const UserExamList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <ReferenceInput key="filter-userId" source="userId" reference="users" />,
      <ReferenceInput key="filter-examId" source="examId" reference="exams" />,
      <ReferenceInput key="filter-courseId" source="courseId" reference="courses" />,
      <BooleanInput key="filter-isTest" source="isTest" />,
      <BooleanInput key="filter-isPassed" source="isPassed" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <ReferenceField source="userId" reference="users" />
      <ChipField source="status" />
      <ReferenceField source="examId" reference="exams" />
      <ReferenceField source="courseId" reference="courses" />
      <BooleanField source="isTest" />
      <ArrayField source="questions">
        <Datagrid>
          <ReferenceField source="questionId" reference="questions" />
          <ReferenceField source="optionId" reference="options" />
          <ReferenceArrayField source="optionIds" reference="options">
            <SingleFieldList linkType={false}>
              <ChipField source="id" />
            </SingleFieldList>
          </ReferenceArrayField>
          <BooleanField source="isCorrect" />
          <TextField source="response" />
        </Datagrid>
      </ArrayField>
      <NumberField source="points" />
      <NumberField source="maxPoints" />
      <NumberField source="minPoints" />
      <BooleanField source="isPassed" />
      <TextField source="reason" />
      <DateField source="startsAt" />
      <TextField source="startApprovedBy" />
      <DateField source="submittedAt" />
    </Datagrid>
  </List>
)

export const UserExamShow = () => (
  <Show>
    <SimpleShowLayout>
      <ReferenceField source="userId" reference="users" />
      <ChipField source="status" />
      <ReferenceField source="examId" reference="exams" />
      <ReferenceField source="courseId" reference="courses" />
      <BooleanField source="isTest" />
      <ArrayField source="questions">
        <Datagrid>
          <ReferenceField source="questionId" reference="questions" />
          <ReferenceField source="optionId" reference="options" />
          <ReferenceArrayField source="optionIds" reference="options">
            <SingleFieldList linkType={false}>
              <ChipField source="id" />
            </SingleFieldList>
          </ReferenceArrayField>
          <BooleanField source="isCorrect" />
          <TextField source="response" />
        </Datagrid>
      </ArrayField>
      <NumberField source="points" />
      <NumberField source="maxPoints" />
      <NumberField source="minPoints" />
      <BooleanField source="isPassed" />
      <TextField source="reason" />
      <DateField source="startsAt" />
      <TextField source="startApprovedBy" />
      <DateField source="submittedAt" />
    </SimpleShowLayout>
  </Show>
)
